import {
  Alert,
  Box,
  Button,
  FormControl,
  Paper,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { useCallback, useState } from "react";
import { PageHeader } from "../../components/PageHeader";
import { WrapperContent } from "../../components/WrapperContent";
import { Messages } from "../../messages";
import { Loader } from "../../components/Loader";
import { auth } from "../../libs/firebase";

const validationSchema = Yup.object().shape({
  accountIdFrom: Yup.string().required(Messages.validations.required),
  accountIdTo: Yup.string().required(Messages.validations.required),
});

export default function TransferProperties() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");

  const clearMessages = useCallback(() => {
    setError("");
    setSuccess("");
  }, []);

  const formik = useFormik({
    initialValues: {
      accountIdFrom: "",
      accountIdTo: "",
    },
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: async (values, { resetForm }) => {
      clearMessages();

      setIsLoading(true);

      try {
        const token = await auth.currentUser?.getIdToken();

        await axios.post(
          `${process.env.REACT_APP_API_URL}/v1/advertisements/transfer`,
          {
            ...values,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setSuccess(
          `¡La transferencia de los inmuebles de la cuenta ${values.accountIdFrom} a la cuenta ${values.accountIdTo} se ha realizado con éxito!`,
        );
        resetForm();
        setIsLoading(false);
      } catch {
        setError("¡Algo salió mal!");
        setIsLoading(false);
      }
    },
  });

  return (
    <WrapperContent>
      <PageHeader title="Transferir Inmuebles" />

      {isLoading && <Loader />}

      <Box sx={{ width: "100%" }}>
        <form onSubmit={formik.handleSubmit}>
          <Paper
            sx={{ mb: 2, p: 1.5 }}
            className="w-full grid grid-cols-2 gap-4"
          >
            {(!!error || !!success) && (
              <div className="col-span-2 mb-4">
                {!!error && <Alert severity="error">{error}</Alert>}
                {!!success && <Alert severity="success">{success}</Alert>}
              </div>
            )}

            <FormControl fullWidth>
              <TextField
                label="AccountID Origen"
                name="accountIdFrom"
                variant="outlined"
                value={formik.values.accountIdFrom}
                onChange={formik.handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="AccountID Destino"
                name="accountIdTo"
                variant="outlined"
                value={formik.values.accountIdTo}
                onChange={formik.handleChange}
              />
            </FormControl>
          </Paper>

          <div className="flex justify-end">
            <Button
              variant="contained"
              size="medium"
              type="submit"
              disableElevation
            >
              Transferir
            </Button>
          </div>
        </form>
      </Box>
    </WrapperContent>
  );
}
